/* eslint-disable @typescript-eslint/naming-convention */
import {
  getIdentityList,
  getLastIdentity,
  getLibraryVideoListWithNoLimit,
  getNativeMaterialList,
} from './../../../service/media';
import { IdentityIntactInfo, IdentityType } from './../../../const/media';
import { getters, state } from './state';
import mutations from './mutations';
import { OriginMaterial } from './../../../pages/media/material';
import adsCreative from './index';
import identityStore from './../identity/index';
const actions = {
  async getLastIdentity(): Promise<any> {
    const { custom_identity = {} as IdentityIntactInfo, tt_identity = {} as IdentityIntactInfo } =
      await getLastIdentity();
    try {
      await actions.getIdentityList();
    } catch (e) {
      console.error(e);
    }

    if (tt_identity?.identity_id) {
      mutations.setCustomIdentity(tt_identity);
    } else {
      if (getters.identityFormData.value.identityList.length) {
        const identity = getters.identityFormData.value.identityList?.[0];
        mutations.setCustomIdentity(identity);
        mutations.setDisplayName(identity.display_name);
        mutations.setImageInfo(identity.avatar_icon);
      }
    }
  },
  async getIdentityList(): Promise<void> {
    const { identity_list } = await getIdentityList(IdentityType.ALL).catch(() => ({ identity_list: [] }));
    const identityList = identity_list?.filter(item => item.identity_type === IdentityType.AUTH_CODE);
    const ownerTikTokAccount = identity_list?.filter(item => item.identity_type === IdentityType.TT_USER);
    mutations.setIdentityList(identityList.concat(ownerTikTokAccount));
    mutations.setTiktokAccountUnderUser(ownerTikTokAccount?.[0]);
  },
  async getIdentityListInit(updateTikTok): Promise<void> {
    const { identity_list } = await getIdentityList(IdentityType.ALL).catch(() => ({ identity_list: [] }));
    const identityList = identity_list?.filter(
      item => item.identity_type === IdentityType.AUTH_CODE || item.identity_type === IdentityType.TT_USER,
    );
    const ownedTikTokAccount = identity_list.filter(item => item.identity_type === IdentityType.TT_USER);
    const fakeUsersList = identity_list.filter(item => item.identity_type === IdentityType.FAKE_USER);
    const fakeUser = fakeUsersList?.[0];
    const tiktokAccountOwnedByUser = ownedTikTokAccount.length === 1 ? ownedTikTokAccount[0] : null;
    const defaultUser = tiktokAccountOwnedByUser ?? identityList?.[0] ?? null;
    // mutations.setLocal
    mutations.setTiktokAccountUnderUser(tiktokAccountOwnedByUser);
    mutations.setIdentityList(identityList);
    if (adsCreative.getters.creativeFormData.value.setFromDraft) {
      return;
    }
    if (fakeUser) {
      mutations.setLocalDisplayName(fakeUser?.display_name);
      mutations.setLocalAvatarIcon(fakeUser?.avatar_icon);
    }

    mutations.setCustomIdentity(defaultUser);
    if (updateTikTok || !state.identity.init.value) {
      identityStore.mutations.setUseTikTokIdentity(Boolean(tiktokAccountOwnedByUser));
      if (!tiktokAccountOwnedByUser) {
        mutations.setDisplayName(fakeUser?.display_name);
        mutations.setImageInfo(fakeUser?.avatar_icon);
      }
      if (tiktokAccountOwnedByUser) {
        mutations.setImageInfo(tiktokAccountOwnedByUser.avatar_icon);
        mutations.setDisplayName(tiktokAccountOwnedByUser.display_name);
      }
    }
  },
  async getNativeMaterialList(identityType: IdentityType, identityId: string): Promise<void> {
    // const { cursor = 0 } = state.identity.nativeInfo.value
    const { tt_native_video_list: nativeList, pagination } = await getNativeMaterialList(
      identityType,
      identityId,
      0,
    ).catch(() => ({ tt_native_video_list: [], pagination: { cursor: 0, has_more: false } }));
    const nativeInfoList = nativeList.map(item => ({
      ...item,
      origin: new OriginMaterial(item?.video_info),
    }));
    mutations.setNativeMaterialInfo(nativeInfoList, pagination?.cursor, pagination?.has_more);
  },
  async getLibraryList(curPage = 1): Promise<void> {
    const { video_list, pagination } = await getLibraryVideoListWithNoLimit(curPage);
    const videos = video_list.map(item => new OriginMaterial(item));
    const page = state.identity?.libraryInfo.value?.videoInfo?.page || 0;
    mutations.setLibraryVideoList(videos, page);
    mutations.setLibraryTotalCount(pagination.total_count);
  },
  async getFreshLibraryList(): Promise<void> {
    const { video_list, pagination } = await getLibraryVideoListWithNoLimit(1);
    const videos = video_list.map(item => new OriginMaterial(item));
    const page = state.identity?.libraryInfo.value?.videoInfo?.page || 0;
    mutations.setClearLibraryVideoList(videos, page);
    mutations.setLibraryTotalCount(pagination.total_count);
  },
};
export default actions;
